// resources/js/router/index.js

import { setupLayouts } from 'virtual:generated-layouts'
import { createRouter, createWebHistory } from 'vue-router/auto'
import { routes as additionalRoutes, redirects } from './additional-routes'
import { setupGuards } from './guards'

function recursiveLayouts(route) {
  // If this route has children, process them but DON'T wrap this parent route
  // The children will be wrapped individually as leaf routes
  if (route.children && route.children.length > 0) {
    // Recursively process children
    route.children = route.children.map(recursiveLayouts)

    // Don't wrap parent routes - they're just groupings
    // The leaf children will get wrapped with layouts
    return route
  }

  // If this is a guest-only route, return it unwrapped
  if (route.meta?.guestOnly) {
    return route
  }

  // Wrap leaf routes (routes without children) with layouts
  return setupLayouts([route])[0]
}

const router = createRouter({
  history: createWebHistory('/'),
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth', top: 60 }
    }
    
    return { top: 0 }
  },
  extendRoutes: autoRoutes => {
    // 1) Remove auto‐generated routes that have manual definitions in additional-routes.js
    const filtered = autoRoutes.filter(r => r.path !== '/login' && r.path !== '/hardware-monitoring')

    // 2) Concatenate your redirects, then filtered auto‐routes, then your additionalRoutes
    const all = [
      ...redirects,
      ...filtered,
      ...additionalRoutes,
    ]

    // 3) Run layout‐wrapping logic
    return all.map(recursiveLayouts)
  },
})

setupGuards(router)

export { router }
export default app => {
  app.use(router)
}
